module.exports = __webpack_public_path__ + "img/gyalapak.4edf5a7e.jpg";